module.exports = __webpack_public_path__ + "0e81ded2fb96fda61fcea50458945749.png";